(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        (function() {
            "use strict";
            if (window.__erkShowroomIntegrationInitialized__) {
                return;
            }
            window.__erkShowroomIntegrationInitialized__ = true;
            const initializedClass = "erk-showroom-integration--initialized";
            function initSection(section) {
                if (!section || section.classList.contains(initializedClass)) return;
                const tabs = Array.from(section.querySelectorAll(".erk-showroom-integration__tab"));
                const panels = Array.from(section.querySelectorAll(".erk-showroom-integration__panel"));
                if (tabs.length === 0 || panels.length === 0) {
                    section.classList.add(initializedClass);
                    return;
                }
                section.classList.add(initializedClass);
                function setActiveTab(activeIndex) {
                    tabs.forEach((function(tab, index) {
                        const isActive = index === activeIndex;
                        tab.classList.toggle("is-active", isActive);
                        tab.setAttribute("aria-selected", isActive ? "true" : "false");
                        tab.tabIndex = isActive ? 0 : -1;
                    }));
                    panels.forEach((function(panel, index) {
                        const isActive = index === activeIndex;
                        panel.classList.toggle("is-active", isActive);
                        panel.hidden = !isActive;
                    }));
                }
                function handleClick(event) {
                    const tab = event.target.closest(".erk-showroom-integration__tab");
                    if (!tab || !section.contains(tab)) return;
                    setActiveTab(Number(tab.dataset.index || 0));
                }
                function handleKeydown(event) {
                    const tab = event.target.closest(".erk-showroom-integration__tab");
                    if (!tab || !section.contains(tab)) return;
                    const currentIndex = tabs.indexOf(tab);
                    let nextIndex = currentIndex;
                    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                        nextIndex = (currentIndex + 1) % tabs.length;
                    } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                    } else if (event.key === "Home") {
                        nextIndex = 0;
                    } else if (event.key === "End") {
                        nextIndex = tabs.length - 1;
                    } else {
                        return;
                    }
                    event.preventDefault();
                    tabs[nextIndex].focus();
                    setActiveTab(nextIndex);
                }
                section.addEventListener("click", handleClick);
                section.addEventListener("keydown", handleKeydown);
                setActiveTab(0);
            }
            function initAll(root) {
                const scope = root || document;
                const sections = scope.querySelectorAll(".erk-showroom-integration:not(." + initializedClass + ")");
                sections.forEach((function(section) {
                    initSection(section);
                }));
            }
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", (function() {
                    initAll();
                }));
            } else {
                initAll();
            }
            document.addEventListener("shopify:section:load", (function(event) {
                initAll(event.target);
            }));
        })();
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();